var path = '/components/components/al-wizard/component.tpl.html';
var html = "<div class=\"content-box\">\n    <ul class=\"wizard box-section-wrap\">\n        <li ng-class=\"{complete: step.completed, current: step.current}\" ng-repeat=\"step in vm.steps track by $index\" ng-if=\"!step.disabled\">\n            <a ng-click=\"vm.clickAction(step)\">\n                <div class=\"step-number\" ng-if=\"step.completed\"><i class=\"fal fa-check\"></i></div>\n                <div class=\"step-number\" ng-if=\"!step.completed\">{{step.index}}</div>\n                <span class=\"step-desc\">{{step.label}}</span>\n            </a>\n        </li>\n    </ul>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/al-wizard/component.tpl.html
// module id = 1962
// module chunks = 1